/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_SubtitleInputs */

const en_pc_tut_subtitle = /** @type {(inputs: Pc_Tut_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eight short lessons in the order you will need them.`)
};

const zh_pc_tut_subtitle = /** @type {(inputs: Pc_Tut_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`八节短课，按你会用到的顺序排列。`)
};

/**
* | output |
* | --- |
* | "Eight short lessons in the order you will need them." |
*
* @param {Pc_Tut_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_subtitle = /** @type {((inputs?: Pc_Tut_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_subtitle(inputs)
	return zh_pc_tut_subtitle(inputs)
});
export { pc_tut_subtitle as "pc.tut.subtitle" }